export class AllowFeature {
  public required = false;
  public display = false;

  constructor(required: boolean, display: boolean) {
    this.required = required;
    this.display = display;
  }
}



// WEBPACK FOOTER //
// ./src/app/model/feature/allow-feature.model.ts